import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ApiRequestTrackerService {
  private activeRequests = new Map<string, number>();
  private isLoadingSubject = new BehaviorSubject<boolean>(false);

  public isLoading$ = this.isLoadingSubject.asObservable();

  public startRequest(apiIdentifier: string): void {
    if (!apiIdentifier) return;

    if (this.activeRequests.has(apiIdentifier)) {
      return;
    }

    this.activeRequests.set(apiIdentifier, 1);
    this.updateLoadingState();
  }

  public endRequest(apiIdentifier: string): void {
    if (!apiIdentifier) return;

    if (this.activeRequests.has(apiIdentifier)) {
      this.activeRequests.delete(apiIdentifier);
      this.updateLoadingState();
    }
  }

  private updateLoadingState(): void {
    this.isLoadingSubject.next(this.activeRequests.size > 0);
  }
}
